module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-32.536f0a73.webp";